import { request } from '@/utils/request.js';

const login = (data, callback, errCallback, finCallback) => {
  request({
    url: '/authenticate/login',
    method: 'POST',
    data: data,
    noToken: true,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const authRefreshToken = (refreshToken, callback, errCallback, finCallback) => {
  request({
    url: '/authenticate/refresh',
    method: 'POST',
    token: refreshToken,
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

const getUserInfo = (callback, errCallback, finCallback) => {
  request({
    url: '/user/user_info',
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback,
  });
};

export { login, register, authRefreshToken, getUserInfo };



// WEBPACK FOOTER //
// ./src/servers/user.js